<script context="module">
    import {tick} from "svelte";
    import {writable} from "svelte/store";

    let elem;
    let top, left, actions;

    let topStore = writable(0), leftStore = writable(0);

    let contextMenuVisible = writable(false);

    export async function showContextMenu(x, y, act) {
        top = y - 5;
        left = x - 5;
        actions = act;
        topStore.set(top);
        leftStore.set(left);

        contextMenuVisible.set(true);

        await tick();

        handleWindowEdge()
    }

    function handleWindowEdge() {
        if (top + elem.clientHeight > window.innerHeight) {
            top = window.innerHeight - elem.clientHeight;
            topStore.set(top);
        }

        if (left + elem.clientWidth > window.innerWidth) {
            left = window.innerWidth - elem.clientWidth;
            leftStore.set(left);
        }

        if (top < 0) {
            top = 0;
            topStore.set(top);
        }

        if (left < 0) {
            left = 0;
            leftStore.set(left);
        }
    }

    function hideMenu() {
        contextMenuVisible.set(false);
    }

    function handleAction(e, act) {
        if (e.button != 0) return
        act.action();
        hideMenu();
    }
</script>

{#if $contextMenuVisible}
    <div class="background" on:mouseup={hideMenu}>

        <ul class="contextMenu box" style="top: {$topStore}px; left:{$leftStore}px;" bind:this={elem}>
            {#each actions as action}
                <li on:mouseup|stopPropagation={(e) => handleAction(e, action)}>{action.name}</li>
            {/each}
        </ul>
    </div>
{/if}

<style>
    .background {
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100vw;
        z-index: 10000;
    }

    .contextMenu {
        position: absolute;
        margin: 0;
        padding: 0;
        background-color: white;
        --border: 1px solid black;
    }

    .contextMenu li:first-of-type {
        padding-top: 10px;
    }

    .contextMenu li:last-of-type {
        padding-bottom: 10px;
        border-bottom: none;
    }

    .contextMenu li {
        cursor: pointer;
        padding: 5px 15px;
        min-width: 150px;
        border-bottom: 1px solid gray;
    }

    .contextMenu li:hover {
        background-color: lightGray;
    }
</style>